export const defaultTokenMapping = {
  // Branded UI colors
  primary: 'brand.primary.v_400',
  primaryDark: 'brand.primary.v_700',
  appBar: 'brand.primary.v_400',
  appBarDark: 'brand.primary.v_700',
  appBarFullscreen: 'palette.grey.v_900',
  appBarFullscreenDark: 'black',
  link: 'brand.primary.v_400',
  linkDark: 'brand.primary.v_700',
  loading: 'brand.secondary.v_200',
  focusOutline: 'brand.secondary.v_200',

  // Generic UI colors
  text: 'palette.grey.v_900',
  textDisabled: 'palette.grey.v_300',
  annotation: 'palette.grey.v_700',
  textInverted: 'palette.white',
  surface: 'palette.white',
  fineLine: '#dedede',

  // general semantic colors
  error: 'palette.red.v_800',
  success: 'palette.green.v_700',

  // Kolibri-specific semantic colors
  progress: 'palette.lightblue.v_500',
  mastered: 'palette.amber.v_500',
  correct: 'palette.green.v_600',
  incorrect: 'palette.red.v_800',
  coachContent: 'palette.lightblue.v_800',
  superAdmin: 'palette.amber.v_600',

  // content colors
  exercise: 'palette.cyan.v_600',
  video: 'palette.indigo.v_700',
  audio: 'palette.pink.v_400',
  document: 'palette.deeporange.v_600',
  html5: 'palette.yellow.v_800',
  topic: 'palette.grey.v_800',
  slideshow: 'palette.green.v_400',
};

// set some arbitrary colors
export const defaultBrandColors = {
  primary: {
    v_50: '#f0e7ed',
    v_100: '#dbc3d4',
    v_200: '#c59db9',
    v_300: '#ac799d',
    v_400: '#996189',
    v_500: '#874e77',
    v_600: '#7c4870',
    v_700: '#6e4167',
    v_800: '#5f3b5c',
    v_900: '#4b2e4d',
  },
  secondary: {
    v_50: '#e3f0ed',
    v_100: '#badbd2',
    v_200: '#8dc5b6',
    v_300: '#62af9a',
    v_400: '#479e86',
    v_500: '#368d74',
    v_600: '#328168',
    v_700: '#2c715a',
    v_800: '#26614d',
    v_900: '#1b4634',
  },
};
